import * as State from '@shared/state';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

export function getPickupMessages(config: IConfig, order$: Observable<State.IOnlineOrderStateItemObj>): IOrderConfirmationPage {
    let orderTypeId: number;

    order$.pipe(take(1)).subscribe(order => {
        orderTypeId = order.data?.OrderTypeId;
    });

    if (!config.collectionTypes?.pickup?.orderTypeIds.includes(orderTypeId)) return;
    const result = config.orderConfirmationPage.find(obj => obj.orderTypeIds.includes(orderTypeId));

    return result;
}

export function getDineInTableMessages(config: IConfig): IOrderConfirmationPage {
    const orderTypeId = config.collectionTypes?.dineIn?.dineInTable?.orderTypeId;
    const result = config.orderConfirmationPage.find(obj => obj.orderTypeIds.includes(orderTypeId));

    return result;
}

export function getDineInBuzzerMessages(config: IConfig): IOrderConfirmationPage {
    const orderTypeId = config.collectionTypes?.dineIn?.dineInBuzzer?.orderTypeId;
    const result = config.orderConfirmationPage.find(obj => obj.orderTypeIds.includes(orderTypeId));

    return result;

}
